module.exports = __webpack_public_path__ + "static/media/medication_p1_2.4ec86621.png";